module.exports = __webpack_public_path__ + "static/media/quantity-ellipsis-stroke.a29e7519.svg";